import { Cell, Row } from "exceljs";

import { COLUMNS } from "./constants";
import { Column, ProcessCensusFileResponse, ProcessedRow } from "./types";

export const findCellByColumn = <T extends string>(
  column: Column<T>,
  row: Row,
): Cell | null =>
  column.fullAddresses.length > 0
    ? (row.findCell(column.fullAddresses[0].col) ?? null)
    : null;

export function trimLowerCase(headerName: string): string {
  return headerName.toLowerCase().replace(/\s+/g, " ").trim();
}

export function getCounterAndLookupFromValues(
  values: string[] = [],
): [Record<string, number>, Record<string, string>] {
  const components = values.reduce<
    [Record<string, number>, Record<string, string>]
  >(
    (acc, value) => {
      const lowercaseValue = value.toLocaleLowerCase();
      acc[0][lowercaseValue] = 0;
      acc[1][lowercaseValue] = value;
      return acc;
    },
    [{}, {}],
  );
  return components;
}

export function getMissingClasses(
  mapCounter: Record<string, number>,
  lookup: Record<string, string>,
): string[] {
  return Object.entries(mapCounter).reduce<string[]>((acc, [key, value]) => {
    if (value === 0) {
      acc.push(lookup[key]);
    }
    return acc;
  }, []);
}

export function getMissingError({
  missing,
  mapCounter,
  lookup,
  type,
}: {
  missing: string[];
  mapCounter: Record<string, number>;
  lookup: Record<string, string>;
  type: "classes" | "dental" | "vision";
}): Extract<ProcessCensusFileResponse, { status: "mapping-error" }> | null {
  if (missing.length > 0 || Object.values(mapCounter).includes(0)) {
    return {
      type,
      status: "mapping-error",
      missing: {
        form: missing,
        census: getMissingClasses(mapCounter, lookup),
      },
    };
  }
  return null;
}

export const getRowId = (processedRow: ProcessedRow): string | null => {
  const dateOfBirth = processedRow[COLUMNS.DATE_OF_BIRTH];
  const zip = processedRow[COLUMNS.ZIP];
  const gender = processedRow[COLUMNS.GENDER];

  if (
    dateOfBirth?.status !== "valid" ||
    zip?.status !== "valid" ||
    gender?.status !== "valid"
  ) {
    return null;
  }

  return [dateOfBirth.processed, zip.processed, gender.processed].join("-");
};
